<script setup lang="ts">
import type { IconName } from "../Icon/icons";
import type { StatusChipTone } from "../StatusChip/VStatusChip.types";
import type { AccessChipKind, VAccessChipProps } from "./VAccessChip.types";
import { computed } from "vue";
import VIcon from "../Icon/VIcon.vue";
import VStatusChip from "../StatusChip/VStatusChip.vue";

defineOptions({
  name: "VAccessChip",
});

const { kind, label } = defineProps<VAccessChipProps>();

// Both kinds read as active: reading is blue with an eye, writing and sending back are orange with a pencil or an
// arrow. A grey chip would look disabled next to them.
const TONES: Record<AccessChipKind, StatusChipTone> = {
  read: "info",
  write: "warning",
  send_back: "warning",
};

const ICONS: Record<AccessChipKind, IconName> = {
  read: "eye",
  write: "pen",
  send_back: "arrow-right",
};

const tone = computed(() => TONES[kind]);
const icon = computed(() => ICONS[kind]);
</script>

<template>
  <VStatusChip :tone="tone" :data-access="kind" class="gap-[5px]">
    <VIcon :name="icon" class="text-[11px]" aria-hidden="true" />{{ label }}
  </VStatusChip>
</template>
